import { render } from "./ReservationDetail.vue?vue&type=template&id=50e1245d&scoped=true"
import script from "./ReservationDetail.vue?vue&type=script&lang=js"
export * from "./ReservationDetail.vue?vue&type=script&lang=js"

import "./ReservationDetail.vue?vue&type=style&index=0&id=50e1245d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e1245d"]])

export default __exports__